/* eslint-disable array-callback-return */
/* eslint-disable no-param-reassign */
/* eslint-disable react/no-unknown-property */
/* eslint-disable no-use-before-define */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable no-debugger */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable max-len */
import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import moment from 'moment';
import { Calendar } from 'react-calendar';
import { createUrl } from '../../redux/helper/CreateQuery';

function FilterModal({
    setFilterModal, handleFetch, filterQuery, setFilterQuery, selected, setselected,
}) {
    const dateRef = useRef();
    const toggleState = {
        start_date: false,
        end_date: false,
        offer_type: false,
        type: false,
    };

    useEffect(() => {
        const handler = (event) => {
            if (dateRef && !dateRef.current.contains(event.target)) {
                settoggle((prevState) => ({
                    ...prevState,
                    start_date: false,
                    end_date: false,
                }));
                // setNotificationDropdown(false)
                // setReportsDropdown(false)
            }
        };
        document.addEventListener('mousedown', handler);

        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, [dateRef]);

    const [toggle, settoggle] = useState(toggleState);
    const AddToSelect = (item, type) => {
        const arr = [...selected[type]];
        const index = arr.indexOf(item);
        if (index === -1) {
            arr.push(item);
        } else {
            arr.splice(index, 1);
        }
        setselected((prevState) => ({
            ...prevState,
            [type]: arr,
        }));
    };

    const generateFilterQuery = () => {
        Object.keys(selected).map((key) => {
            switch (key) {
            case 'industrial_pocket':
                if (selected[key].length > 0) {
                    filterQuery[key] = selected[key];
                }
                break;
            case 'status':
                if (selected[key].length > 0) {
                    filterQuery.offer_status = selected[key];
                }
                break;
            default: break;
            }
        });
        if (selected.start_date !== '' && selected.end_date !== '') {
            filterQuery.date = `${moment(selected.start_date).format('YYYY/MM/DD')}-${moment(selected.end_date).format('YYYY/MM/DD')}`;
        }handleFetch(filterQuery);
        setFilterModal(false);
    };
    const handleToggle = (key) => {
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
        }));
    };
    const handleDate = (val, key) => {
        const state = key === 'start_date' ? 'end_date' : 'start_date';
        if (key === 'start_date') {
            setselected((prevState) => ({
                ...prevState,
                end_date: '',
            }));
        }
        settoggle(toggleState);
        if (key === 'end_date') {
            settoggle(toggleState);
        } else {
            setTimeout(() => {
                handleToggle(state);
            }, 500);
        }
        setselected((prevState) => ({
            ...prevState,
            [key]: val,
        }));
        if (key === 'end_date') {
            settoggle(toggleState);
        }
    };
    return (
        <div
            className="modal-dialog modal-dialog-centered relative max-w-[650px] pointer-events-none mt-0 mr-0 mb-0 h-full shadow-4xl bg-[#ffffff]"
        >
            <div
                className="modal-content border-none relative flex flex-col w-full pointer-events-auto bg-clip-padding outline-none text-current h-full"
            >
                <img
                    className="p-2 rounded-full cursor-pointer absolute top-4 right-4"
                    src="images/Component158–2.svg"
                    alt="close-icon"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => setFilterModal(false)}
                />
                <div className="pt-[64px] pb-5 bg-[#ffffff]">
                    <div className="pl-[60px] sticky top-0 left-0 z-10 bg-[#FFFFFF]">
                        <div className="flex justify-between pr-5">
                            <h2 className="text-xl font-bold text-[#555259]">
                                Filter (s)
                            </h2>
                            <div>
                                {(selected.offer_type.length > 0 || selected.industrial_pocket.length > 0 || selected.status.length > 0 || selected.start_date !== '' || selected.end_date !== '') && (
                                    <p
                                        className="text-base font-bold text-[#555259] cursor-pointer pr-10"
                                        onClick={() => {
                                            setselected({
                                                offer_type: [],
                                                industrial_pocket: [],
                                                status: '',
                                                start_date: '',
                                                end_date: '',
                                            });
                                            setFilterQuery({
                                                page: 1,
                                                limit: 8,
                                                sort: 'created_at desc',
                                            });
                                            setFilterModal(false);
                                            handleFetch();
                                        }}
                                    >
                                        Clear
                                        {' '}

                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="px-14 bg-[#FFFFFF]">
                        <div className="mt-6 bg-[#F5F5FA] rounded-md px-2 pt-6">
                            <div className="mt-[18px]">
                                <h5 className="text-base font-semibold text-[#555259]">Type</h5>
                                <div className="px-1 mt-4">
                                    <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 custom-checkbox3 flex items-center">
                                        <input type="checkbox" id="checkbox-1214" checked={selected.industrial_pocket.includes('HIP')} onChange={() => AddToSelect('HIP', 'industrial_pocket')} />
                                        <label htmlFor="checkbox-1214" className="pl-3 text-base font-normal cursor-pointer text-[#555259]">HIP</label>
                                    </div>
                                </div>
                                <div className="px-1 mt-2.5">
                                    <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 custom-checkbox3 flex items-center">
                                        <input type="checkbox" id="checkbox-1114" checked={selected.industrial_pocket.includes('MIP')} onChange={() => AddToSelect('MIP', 'industrial_pocket')} />
                                        <label htmlFor="checkbox-1114" className="pl-3 text-base cursor-pointer font-normal text-[#555259]">MIP</label>
                                    </div>
                                </div>
                                <div className="px-1 mt-2.5">
                                    <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 custom-checkbox3 flex items-center">
                                        <input type="checkbox" id="checkbox-1119" checked={selected.industrial_pocket.includes('ALL')} onChange={() => AddToSelect('ALL', 'industrial_pocket')} />
                                        <label htmlFor="checkbox-1119" className="pl-3 text-base cursor-pointer font-normal text-[#555259]">ALL</label>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-[18px]">
                                <h5 className="text-base font-semibold text-[#555259]">Status</h5>
                                <div className="px-1 mt-4">
                                    <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 custom-checkbox3 flex items-center">
                                        <input type="checkbox" id="checkbox-1014" checked={selected.status.includes('1')} onChange={() => AddToSelect('1', 'status')} />
                                        <label htmlFor="checkbox-1014" className="pl-3 text-base cursor-pointer font-normal text-[#555259]">Active</label>
                                    </div>
                                </div>
                                <div className="px-1 mt-2.5">
                                    <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 custom-checkbox3 flex items-center">
                                        <input type="checkbox" id="checkbox-11014" checked={selected.status.includes('0')} onChange={() => AddToSelect('0', 'status')} />
                                        <label htmlFor="checkbox-11014" className="pl-3 text-base cursor-pointer font-normal text-[#555259]">Inactive</label>
                                    </div>
                                </div>
                                <div className="px-1 mt-2.5">
                                    <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 custom-checkbox3 flex items-center">
                                        <input type="checkbox" id="checkbox-11114" checked={selected.status.includes('2')} onChange={() => AddToSelect('2', 'status')} />
                                        <label htmlFor="checkbox-11114" className="pl-3 text-base cursor-pointer font-normal text-[#555259]">Expired</label>
                                    </div>
                                </div>
                                <div className="px-1 mt-2.5">
                                    <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 custom-checkbox3 flex items-center">
                                        <input type="checkbox" id="checkbox-10114" checked={selected.status.includes('3')} onChange={() => AddToSelect('3', 'status')} />
                                        <label htmlFor="checkbox-10114" className="pl-3 text-base cursor-pointer font-normal text-[#555259]">Draft</label>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="mt-[18px] pb-[110px]"
                                ref={dateRef}
                            >
                                <h5 className="text-base font-semibold text-[#555259]">Date</h5>
                                <div className="flex items-center mt-3">
                                    <div
                                        className="relative w-1/2"
                                        onClick={() => handleToggle('start_date')}
                                    >
                                        <label />
                                        <img
                                            src="images/Iconawesome-calendar-alt.svg"
                                            onClick={() => handleToggle('start_date')}
                                            alt="icon"
                                            className="absolute top-3 right-2.5 cursor-pointer"
                                        />
                                        <input
                                            datepicker
                                            datepicker-autohide
                                            value={selected.start_date === '' ? '' : moment(selected.start_date).format('YYYY/MM/DD').split('/').reverse()
                                                .join('/')}
                                            type="text"
                                            className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs2 placeholder:font-normal placeholder:text-[#808285]"
                                            placeholder="Select Date"
                                        />

                                    </div>
                                    {toggle.start_date && <Calendar value={moment(selected.start_date).format('YYYY/MM/DD').start_date} onChange={(val) => handleDate(val, 'start_date')} />}

                                    <p className="text-base font-normal text-[#555259] px-2.5">to</p>
                                    <div
                                        className="relative w-1/2"
                                        onClick={() => handleToggle('end_date')}
                                    >
                                        <label />
                                        <img
                                            src="images/Iconawesome-calendar-alt.svg"
                                            onClick={() => handleToggle('end_date')}
                                            alt="icon"
                                            className="absolute top-3 right-2.5 cursor-pointer"
                                        />
                                        <input
                                            value={selected.end_date === '' ? '' : moment(selected.end_date).format('YYYY/MM/DD').split('/').reverse()
                                                .join('/')}
                                            datepicker
                                            datepicker-autohide
                                            type="text"
                                            className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs2 placeholder:font-normal placeholder:text-[#808285]"
                                            placeholder="Select Date"
                                        />

                                    </div>
                                    {toggle.end_date && <Calendar value={selected.end_date} onChange={(val) => handleDate(val, 'end_date')} minDate={moment(selected.start_date).toDate()} />}

                                </div>
                            </div>
                        </div>

                        <motion.button
                            animate={{ y: 10 }}
                            transition={{ delay: 1 }}
                            type="button"
                            className="mt-[22px] text-lg font-semibold text-[#FFFFFF] w-full h-[52px] rounded-[16px] bg-[#555259] mb-5"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => generateFilterQuery()}
                        >
                            Apply Filter(s)
                        </motion.button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FilterModal;
